export * from "./routes";
export * from "./api";

// Alert message constants
export const ALERT_TITLES = {
  WARNING: "Warning!",
  SUCCESS: "Success!",
  ERROR: "Error!",
  INFO: "Action Required!",
  CONFIRMATION: "Confirmation!",
};

export const ALERT_MESSAGES = {
  // Navigation and General
  UNLOAD_WARNING: "Are you sure you want to leave? Your progress may be lost.",
  UNSAVED_CHANGES:
    "You have unsaved changes. Are you sure you want to exit without saving your updates?",
  SUCCESS_SIGNUP: "Registration Successful! Your account is now under review.",
  DELETE_CONFIRMATION: "Are you sure to delete?",
  // File Upload
  INVALID_FILE_FORMAT: "You must upload in PDF, JPEG, or PNG formats only.",
  DOCUMENT_UPLOAD_SUCCESS: "You uploaded documents successfully.",
  GPS_ERROR: "Automatic changing Postal Code to Address failed.",
  AGREE_TA: "Please check 'I read and agreed to the Terms & Conditions'.",

  // OTP
  OTP_RESENT: "A new OTP has been sent to your email.",

  // KYB (Know Your Business)
  KYB_CONFIRMATION:
    "Do you want to continue to the Know Your Business (KYB) section?",

  // Address Validation
  INVALID_POSTAL_CODE: "Please enter a valid Singapore postal code (6 digits).",
  ADDRESS_RETRIEVAL_FAILED:
    "Failed to retrieve address. Please enter a valid Singapore postal code.",
  ASK_LEAVE: "Are you sure you want to leave? Your progress may be lost.",

  UPLOAD_REQUIRED:
    "Please complete all required fields and upload the necessary documents.",
};

// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

// Order status constants
export const ORDER_STATUS = {
  PENDING: "pending",
  CONFIRMED: "confirmed",
  PREPARING: "preparing",
  READY_FOR_PICKUP: "ready_for_pickup",
  OUT_FOR_DELIVERY: "out_for_delivery",
  DELIVERED: "delivered",
  CANCELLED: "cancelled",
};

// Payment status constants
export const PAYMENT_STATUS = {
  PENDING: "pending",
  PAID: "paid",
  FAILED: "failed",
  REFUNDED: "refunded",
};

// Time constants
export const TIME_FORMATS = {
  DEFAULT: "MMM DD, YYYY hh:mm A",
  DATE_ONLY: "MMM DD, YYYY",
  TIME_ONLY: "hh:mm A",
};

// Local storage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: "send_merchant_auth_token",
  REFRESH_TOKEN: "send_merchant_refresh_token",
  USER_DATA: "authUser",
  THEME_PREFERENCE: "send_merchant_theme",
};

// Default pagination
export const DEFAULT_PAGINATION = {
  PAGE: 1,
  LIMIT: 10,
};

// const REACT_APP_API_BASE_URL = "https://prodapi.betasendapp.com/";
const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const apiURL_provider = REACT_APP_API_BASE_URL + "serviceprovider/api";
export const apiURL_user = REACT_APP_API_BASE_URL + "user/api";
export const apiURL_order = REACT_APP_API_BASE_URL + "order/api";
export const apiURL_payment = REACT_APP_API_BASE_URL + "payment/api";
export const apiURL_courier = REACT_APP_API_BASE_URL + "courier/api";
export const apiURL_admin = REACT_APP_API_BASE_URL + "admin/api";
export const apiURL_livehosting = REACT_APP_API_BASE_URL + "livehosting/api";

//uat

// export const apiURL_provider = process.env.REACT_APP_API_BASE_URL+"serviceprovider";
// export const apiURL_user = process.env.REACT_APP_API_BASE_URL+"user";
// export const apiURL_order = process.env.REACT_APP_API_BASE_URL+"order";
// export const apiURL_payment = process.env.REACT_APP_API_BASE_URL+"payment";
// export const apiURL_courier = process.env.REACT_APP_API_BASE_URL+"courier";
// export const apiURL_admin = process.env.REACT_APP_API_BASE_URL+"admin";
// export const apiURL_livehosting = process.env.REACT_APP_API_BASE_URL+"livehosting";

export const roles = {
  1: "customer",
  2: "serviceprovider",
  3: "admin",
  4: "courier",
  5: "loanofficer",
  6: "loanmanager",
  7: "consumerrider",
};

export const defaultPageSize = 3;

export const defaultSizeCarouselWeb = 3;
export const defaultSizeCarouselMobile = 1;

export const LIVE_STREAM_CHAT_TYPE = {
  reaction: "reaction",
  message: "message",
  ticker: "ticker",
};

export const LIVE_STREAM_Status_Label: Record<number, string> = {
  0: "All",
  1: "Now",
  2: "Past",
  3: "Scheduled",
};
// export const vapid_key =
//   "BHCIIr60CFlEBFxf6wWlPMWxEJwQljM2seAI508uC8pbGETV_qb-JnPM2q6cPTU6KRl57KJaha4J5IiBYk-NAIo";
export const vapid_key = process.env.REACT_APP_VAPID_KEY as string;

// export const GOOGLE_API_KEY = "AIzaSyBXjx0MZqc2aB9q6fDoV68J2EA1VRpVG94";
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY as string;
export const travel_mode = "walking";

export const lang = () => {
  return "en";
  // return localStorage.getItem("i18nextLng") === "en-US"
  //   ? "en"
  //   : localStorage.getItem("i18nextLng");
};

export const validator = {
  not_valid: 400,
};

// Define allowed file types as a string for the accept attribute
export const allowedFileType_merchantDocuments = ".jpeg,.png,.pdf";
// Create a RegExp for file validation
export const allowedFileTypeRegex = /\.(jpe?g|png|pdf)$/i;

export const encryptedAPINames = [
  { id: 1, value: "UserSignUp" },
  { id: 2, value: "UserConfirmation" },
  { id: 3, value: "UpdateUser" },
  // { id: 4, value: "UserLogin" },
  { id: 5, value: "UserLoginConfirmation" },
  { id: 6, value: "ForgotPasswordRequest" },
  { id: 7, value: "ResetPassword" },
  { id: 8, value: "SocialSignUp" },
  { id: 9, value: "SocialLogin" },
  { id: 10, value: "CreateUserAddress" },
  { id: 11, value: "UpdateUserAddress" },
  { id: 12, value: "MerchantSignUp" },
  { id: 13, value: "CreateServiceProvider" },
  { id: 14, value: "SPConfirmation" },
  { id: 15, value: "RollbackMerchant" },
  { id: 16, value: "UpdateServiceProvider" },
  { id: 17, value: "CreateProduct" },
  { id: 18, value: "UpdateProduct" },
  // { id: 19, value: "CreateMenu" },
  // { id: 20, value: "UpdateMenu" },
  { id: 21, value: "CreateCuisine" },
  { id: 22, value: "CreateOffer" },
  { id: 23, value: "CreateDietary" },
  { id: 24, value: "CreateFoodCategory" },
  // { id: 25, value: "CreateBundleDeal" },
  // { id: 26, value: "UpdateBundleDeal" },
  { id: 27, value: "CreateDiscount" },
  { id: 28, value: "UpdateDiscount" },
  { id: 29, value: "CreateOrder" },
  { id: 30, value: "UpdateOrder" },
  { id: 31, value: "CancelOrder" },
  { id: 32, value: "CreateConsumerRider" },
  { id: 33, value: "CreateCourierAssign" },
  { id: 34, value: "UpdateCourierAssign" },
  { id: 35, value: "CreateOrderState" },
  { id: 36, value: "UpdateOrderState" },
  { id: 37, value: "CreatePeerCheckIn" },
  { id: 38, value: "SignPdfByServiceProvider" },
];

// export const pemPublicKey = `-----BEGIN PUBLIC KEY-----
// MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEArRe8TmVVIwAUagcee5xt
// IOWcm+YZpd2OK3yBGWtgBTSaPAQVz3qqnH2881n6s2i+lwX9+adblrN+4Urkii3s
// 9KlNVeeFrMglTlxJpuAlDgjkBn39sicUpXdhMRSSBH9QczveeR2/Jy8U8+KPIHQg
// eVc6xz0LNbfTuVa8JDUWIpOSoosJzoYj6zo4kmteHnOTsCK/VBM2vAVKTi2F9eo7
// wnS0+lu/pwrq9Q7fIcal6lmKk1GK0WMnDgZSxemQB1nUlnsnz34y6EGTwQ1EdA60
// QPYUlDbBlVU3tlAczVkKhFxCNQQBb3cbAJsO0HpZBEABM2rH/ZaA5W9q8D37AWj1
// sCU8UnDVeJSaGacLwrNpcIkOj4JyIsdYI6qt5EUcZr7ATZP0KRBjhjt/Qgu1lthW
// gz8Ev18krRuDHIGUXYa0lSJ1zIrrpfzow1OX88XnxwIB6cshDs1BbGOdr/7exadE
// pSE/iEQRHzR+pW5H8TPMCtndYXOiUMlz66LhWukXtjO6KnmyfLkH4im+tKGDDq5L
// F37t53x1mkYvtp4kLhAVHh1oTN6wkLFis6fQviakL0x2z1cegAzm88G8BnGHv0I4
// Z/eFu6bQw7QYnJ8eJ6zsC3CCU+FbfNhUqplpPK+oq0wngj3jbcVRzYF4ss0UKKjq
// hEESKcVXxaRBFXykoHj6r1ECAwEAAQ==
// -----END PUBLIC KEY-----`;

export const pemPublicKey = process.env.REACT_APP_PEM_PUBLIC_KEY as string;

export interface OnBoardingStepProps {
  formData: any;
  changedRole?: boolean;
  isFromProfile?: boolean;
  isAuthenticated?: boolean;
  onChange: (field: string, value: any) => void;
  onNext: (res?: any) => void;
  onBack: (res?: any) => void;
  onAssign: (res?: any) => void;
}

export interface FileItem {
  id: string;
  imagePath: File;
}

export interface FileNameItem {
  id: string;
  imageName: string;
}
